<template>

<nav class="navbar navbar-expand-lg navbar-success bg-success navBg" :class="[currentRouteName == 'Home' ? 'navbar-transparent' : '',$store.getters.getTempalte.headerScroll]">
  <div class="container-fluid">
    <router-link class="navbar-brand d-flex align-items-center" :to="{ name: 'Home' }">
      <img src="../../assets/secclogo.png" alt="DBK Logo" class="img-logo"> 
      <span class="logo moul" >
            {{$t("message.serc")}}
          </span>
    </router-link>
    <button class="navbar-toggler" style="color:white;" type="button" 
          @click="toggleDrawer"
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNavDropdown" 
          aria-controls="navbarNavDropdown" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    <!-- <div v-if="!auth.access_token" class="">
      <ul class="navbar-nav" >
        <li class="nav-item" v-if="!auth.access_token">
          <router-link class="nav-link link-warning" :to="{ name: 'SingUp' }">
            {{$t("message.create_account")}}
          </router-link>
        </li>
        <li class="nav-item" v-if="!auth.access_token">
          <router-link class="nav-link link-warning" :to="{ name: 'SystemLogin' }">
            {{$t("message.login")}}
          </router-link>
        </li>
      
        <li class="nav-item">
            <a class="nav-link link-warning" @click="changeLanguage">
              <img
                v-if="$store.state.lan == 'en'"
                style="width: 20px;"
                src="../../assets/images/en.svg"
              />
              <img v-else src="../../assets/images/kh.svg" style="width: 20px;"/>
            </a>
        </li>
      </ul>
    </div> -->

    <div class="collapse navbar-collapse d-none d-sm-block d-sm-none d-md-block d-md-none d-lg-block" id="navbarNavDropdown">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" v-if="auth.access_token">
          <a class="nav-link mx-2 link-warning" @click="gotoDashboard">Dashboard</a>
        </li>

        <li class="nav-item" v-if="!auth.access_token">
          <router-link class="nav-link link-warning" :to="{ name: 'SingUp' }">
            {{$t("message.create_account")}}
          </router-link>
        </li>
        <li class="nav-item" v-if="!auth.access_token">
          <router-link class="nav-link link-warning" :to="{ name: 'SystemLogin' }">
            {{$t("message.login")}}
          </router-link>
        </li>
        
       
        <li class="nav-item">
            <a class="nav-link link-warning" @click="changeLanguage">
              <img
                v-if="$store.state.lan == 'kh'"
                style="width: 20px;"
                src="../../assets/images/en.svg"
              />
              <img v-else src="../../assets/images/kh.svg" style="width: 20px;"/>
            </a>
        </li>
        <li class="nav-item dropdown" v-if="auth.access_token">
          <a class="nav-link mx-2 dropdown-toggle link-warning" href="#" 
            id="navbarDropdownMenuLink" 
            role="button" 
            data-bs-toggle="dropdown" 
            aria-expanded="false">
              {{ auth.user.name }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
             <li v-if="$store.getters.getAuthRole[0]=='user'"><a class="dropdown-item" @click="goToPersonalInfo">{{$t("message.profile")}}</a></li>
            <li>
              <a class="dropdown-item" @click="logout"> 
                {{$t("message.logout")}}
                <i class="fas fa-sign-out-alt"></i>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/axios";
export default {
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale == "en" ? "kh" : "en";
      this.$store.dispatch("act_changLanguage");
    },
    toggleDrawer(){
        this.$store.dispatch("act_toggleDrawer");
    },
    async logout() {
      //this.act_logoutAuth();
      this.$swal
        .fire({
          title: this.$t("message.do_you_want_to_logout"),
          showCancelButton: true,
          confirmButtonText: this.$t("message.yes"),
          cancelButtonText: this.$t("message.no")
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const respone = await axios.post("logmeout", {}, {
              headers: {
                Authorization: "Bearer " + this.$store.getters.getAuthToken
              }
            });
            if (respone.status == 200) {
               this.$store.dispatch("act_logoutAuth");
              this.$router.push({ name: "Home" });
            }
          }
        });
    },
    gotoDashboard(){
      if(this.$store.getters.getAuthRole[0]=='supperAdmin' || this.$store.getters.getAuthRole[0]=='Admin'){
        this.$router.push({ name: "adminNewRegistor" });
      }else if(this.$store.getters.getAuthRole[0]=='Account'){
        this.$router.push({ name: "invoiceManagement" });
      }else{
        this.$router.push({ name: "myRegistration" });
      }
    },
    goToPersonalInfo(){
      this.$router.push("/dashboard/personal");
    }

  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      auth: "getAuth"
    }),
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>
<style>
.avatar {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.nav-link, .dropdown-item {
  cursor: pointer;
}
.navBg {
  background: rgba(10, 92, 44, 0.96) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
  padding: 10px 24px !important;
  transition: all 0.3s ease;
}
.img-logo {
  height: 44px !important;
  margin-right: 12px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.navbar-brand:hover .img-logo {
  transform: rotate(-3deg) scale(1.05);
}
.logo.moul {
  font-family: 'Moul', 'Khmer Moul', cursive;
  font-size: 1.2rem;
  color: #ffc107 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.logo.moul:hover {
  color: #ffffff !important;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
}
.navBg .nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px !important;
  border-radius: 6px;
  transition: all 0.25s ease;
}
.navBg .nav-link:hover {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
}
.navBg .nav-link.link-warning {
  color: #ffc107 !important;
}
.navBg .nav-link.link-warning:hover {
  color: #ffffff !important;
  background-color: rgba(255, 193, 7, 0.12);
}
.navBg .dropdown-menu {
  background: rgba(12, 26, 18, 0.98) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25) !important;
  border-radius: 8px !important;
  padding: 6px !important;
  margin-top: 8px !important;
}
.navBg .dropdown-item {
  color: rgba(255, 255, 255, 0.8) !important;
  padding: 8px 16px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
}
.navBg .dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
}
.navBg .dropdown-item i {
  margin-left: 8px;
  font-size: 12px;
  color: #dc3545;
}
</style>
